import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import { AgGridAngular } from 'ag-grid-angular';
import { ColDef, GridOptions } from 'ag-grid-community';
import { LinkButtonComponent } from '../../../core/components/buttons/link/link-button.component';
import { AG_GRID_DEFAULT_OPTIONS } from '../../../core/config/aggrid.default.config';
import { Cliente } from '../../../models/clientes/cliente.model';
import { ClientesService } from '../../services/clientes.service';

@Component({
  selector: 'app-clientes',
  standalone: true,
  imports: [CommonModule, RouterModule, AgGridAngular, MatIconModule],
  templateUrl: './clientes.component.html',
  styleUrl: './clientes.component.scss',
})
export default class ClientesComponent implements OnInit {
  clientes: Cliente[] = [];

  constructor(
    private readonly clientesService: ClientesService,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    this.obtenerClientes();
  }

  gridOptions: GridOptions = { ...AG_GRID_DEFAULT_OPTIONS, onRowDoubleClicked: this.onRowDoubleClicked.bind(this) };
  columnDefs: ColDef[] = [
    { field: 'id', headerName: 'ID' },
    { field: 'nombreCompleto', headerName: 'Nombre' },
    { field: 'numeroDocumento', headerName: 'Identificativo' },
    { field: 'direccionCompleta', headerName: 'Dirección' },
    { field: 'correo', headerName: 'Email' },
    { field: 'movil', headerName: 'Teléfono' },
    {
      field: 'actions',
      headerName: 'Opciones',
      cellRenderer: LinkButtonComponent,
      cellRendererParams(params: any) {
        return {
          link: `/clientes/${params.data.id}`,
        };
      },
      resizable: false,
      sortable: false,
      filter: false,
      suppressMovable: true,
    },
  ];

  obtenerClientes(): void {
    this.clientesService.getClientes().subscribe({
      next: (data) => {
        this.clientes = data;
      },
      error: (err) => {
        console.error('ClientesComponent - Error:', err);
      },
    });
  }

  onRowDoubleClicked(event: any): void {
    const clienteId = event.data.id;
    this.router.navigate([`/clientes/${clienteId}`]);
  }
}
